function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from "underscore";
import PropTypes from "prop-types";
import React from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import OutsideClick from "../elements/outside-click";
import BasicUtils from "../../utils/basic-utils";
var ARROW_BORDER_SIZE = 1;
var OVERFLOW_MARGIN = 10;

var _titleize = function _titleize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

var Overlay = /*#__PURE__*/function (_React$Component) {
  _inherits(Overlay, _React$Component);

  var _super = _createSuper(Overlay);

  function Overlay() {
    var _this;

    _classCallCheck(this, Overlay);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      height: 100,
      width: _this.props.width || 175,
      content_position: {},
      arrow_position: {},
      arrow_position_adjusted: {}
    });

    _defineProperty(_assertThisInitialized(_this), "handleOutsideClick", function () {
      return typeof _this.props.onClose === "function" ? _this.props.onClose() : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "getArrowPosition", function () {
      var _this$props$origin = _this.props.origin,
          width = _this$props$origin.width,
          height = _this$props$origin.height;
      var size = _this.props.arrowSize;

      var pos = _this.props.position.split("-")[0];

      var position = function () {
        switch (pos) {
          case "top":
            return {
              left: width / 2 - size,
              top: -size
            };

          case "bottom":
            return {
              left: width / 2 - size,
              top: height
            };

          case "right":
            return {
              left: width,
              top: height / 2 - size
            };

          case "left":
            return {
              left: -size,
              top: height / 2 - size
            };
        }
      }();

      var arrow_position = _.extend({
        left: position.left,
        top: position.top
      }, _this.props.arrowPosition);

      _this.setState({
        arrow_position: arrow_position
      });

      return _this.getArrowBorderAdjust(arrow_position);
    });

    _defineProperty(_assertThisInitialized(_this), "getArrowBorderAdjust", function (arrow_position) {
      var pos = _this.props.position.split("-")[0];

      var arrow_position_adjusted = function () {
        switch (pos) {
          case "top":
            return {
              top: arrow_position.top - ARROW_BORDER_SIZE
            };

          case "bottom":
            return {
              top: arrow_position.top + ARROW_BORDER_SIZE
            };

          case "left":
            return {
              left: arrow_position.left - ARROW_BORDER_SIZE
            };

          case "right":
            return {
              left: arrow_position.left + ARROW_BORDER_SIZE
            };
        }
      }();

      return _this.setState({
        arrow_position_adjusted: arrow_position_adjusted
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getContentPosition", function (width, height) {
      var origin = _this.props.origin;
      width = _this.props.width || width; // width of the popover content

      height = _this.props.height || height;
      var arrow = _this.props.arrowSize;
      var top_aligned_margin = -10; // to position the arrow a little below the top of the popover

      var position = function () {
        switch (_this.props.position) {
          case "top":
            return {
              left: origin.width / 2 - width / 2,
              top: -(height + arrow)
            };

          case "bottom":
            return {
              left: origin.width / 2 - width / 2,
              top: origin.height + arrow
            };

          case "right":
            return {
              left: origin.width + arrow,
              top: origin.height / 2 - height / 2
            };

          case "left":
            return {
              left: -(width + arrow),
              top: origin.height / 2 - height / 2
            };

          case "bottom-left-aligned":
            return {
              left: 0,
              top: origin.height + arrow
            };

          case "bottom-right-aligned":
            return {
              left: -width + origin.width,
              top: origin.height + arrow
            };

          case "left-top-aligned":
            return {
              left: -(width + arrow),
              top: top_aligned_margin
            };

          case "right-top-aligned":
            return {
              left: origin.width + arrow,
              top: top_aligned_margin
            };
        }
      }(); // Adjust Content container for window overflow


      if (["top", "bottom"].includes(_this.props.position)) {
        var window_width = window.outerWidth;
        var offset_left = _this.props.origin.left + position.left;
        var offset_right = _this.props.origin.left + position.left + width;

        if (offset_left < 0) {
          position.left += Math.abs(offset_left) + OVERFLOW_MARGIN;
        } else if (offset_right > window_width) {
          position.left -= offset_right - window_width + OVERFLOW_MARGIN;
        }
      } else if (["left", "right"].includes(_this.props.position)) {
        var window_height = window.outerHeight;
        var offset_top = _this.props.origin.top + position.top;
        var offset_bottom = _this.props.origin.top + position.top + height;

        if (offset_top < 0) {
          position.top += Math.abs(offset_top) + OVERFLOW_MARGIN;
        } else if (offset_bottom > window_height) {
          position.top -= offset_bottom - window_height + OVERFLOW_MARGIN;
        }
      }

      return _this.setState({
        content_position: {
          top: position.top,
          left: position.left
        }
      });
    });

    return _this;
  }

  _createClass(Overlay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var content = ReactDOM.findDOMNode(this.bodyEl);
      this.getContentPosition(content.offsetWidth, content.offsetHeight);
      return this.getArrowPosition();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var position = this.props.position.split("-")[0];
      return /*#__PURE__*/React.createElement("div", {
        className: classNames("et--overlay", this.props.className)
      }, /*#__PURE__*/React.createElement(OutsideClick, {
        ref: function ref(el) {
          return _this2.bodyEl = el;
        },
        className: "et--overlay--content",
        onOutsideClick: this.handleOutsideClick,
        style: this.state.content_position
      }, this.props.children), this.props.arrowSize > 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "et--overlay--arrow is-".concat(position),
        style: _.extend({}, this.state.arrow_position, {
          borderWidth: this.props.arrowSize
        }, BasicUtils.toObject("border".concat(_titleize(position), "Color"), this.props.arrowBorderColor))
      }), /*#__PURE__*/React.createElement("div", {
        className: "et--overlay--arrow is-".concat(position),
        style: _.extend({}, this.state.arrow_position, this.state.arrow_position_adjusted, {
          borderWidth: this.props.arrowSize
        }, BasicUtils.toObject("border".concat(_titleize(position), "Color"), this.props.arrowColor))
      })) : undefined);
    }
  }]);

  return Overlay;
}(React.Component);

_defineProperty(Overlay, "displayName", "Overlay");

_defineProperty(Overlay, "propTypes", {
  position: PropTypes.oneOf(["top", "bottom", "left", "right", "bottom-right-aligned", "bottom-left-aligned", "left-top-aligned", "right-top-aligned"]),
  width: PropTypes.number,
  height: PropTypes.number,
  origin: PropTypes.object,
  arrowSize: PropTypes.number,
  arrowColor: PropTypes.string,
  arrowBorderColor: PropTypes.string,
  arrowPosition: PropTypes.object,
  onClose: PropTypes.func
});

_defineProperty(Overlay, "defaultProps", {
  position: "bottom",
  origin: {
    width: 175,
    height: 10,
    top: 0,
    left: 0
  },
  arrowSize: 11,
  arrowColor: "#fff",
  arrowBorderColor: "#d2dde0"
});

export { Overlay as default };